import { defineComponent } from 'vue';
import ALink from './aLink/index.vue';

export const Purchase = defineComponent({
  name: 'Purchase',
  setup() {
    const { $t } = useNuxtApp();
    const url = !isChinese()
      ? '//protocol.rendora.ai/legal/purchase'
      : '//frontend-protocol.xmov.ai/youyan-v3/purchase';
    return () => (
      <ALink href={url} name="purchase" class={'text-[12px]'}>
        {$t('mo-fa-you-yan-ruan-jian-chan-pin-gou-mai-xie-yi')}
      </ALink>
    );
  },
});

export const Subscription = defineComponent({
  name: 'Subscription',
  setup() {
    const { $t } = useNuxtApp();
    const url = !isChinese()
      ? '//protocol.rendora.ai/legal/purchase'
      : '//frontend-protocol.xmov.ai/youyan-v3/subscription';
    return () => (
      <ALink href={url} name="subscription" class={'text-[12px]'}>
        {$t('mo-fa-you-yan-zi-dong-xu-fei-xie-yi')}
      </ALink>
    );
  },
});

export const User = defineComponent({
  name: 'User',
  setup() {
    const { $t } = useNuxtApp();
    const url = !isChinese()
      ? '//protocol.rendora.ai/legal/user'
      : '//frontend-protocol.xmov.ai/youyan-v3/user';
    return () => (
      <ALink href={url} name="user" class={'text-[12px]'}>
        {$t('mo-fa-you-yan-yong-hu-xie-yi-0')}
      </ALink>
    );
  },
});

export const CreditCoin = defineComponent({
  name: 'User',
  setup() {
    const { $t } = useNuxtApp();
    const url = !isChinese()
      ? '//protocol.rendora.ai/legal/credit-coin'
      : '//frontend-protocol.xmov.ai/youyan-v3/credit-coin';
    return () => (
      <ALink href={url} name="coin" class={'text-[12px]'}>
        {$t('yan-bi-fu-wu-xie-yi')}
      </ALink>
    );
  },
});
